<template>
  <div>
    <SMTP :settings="settings" />
    <RPTrage
      v-if="isRPTradeModule"
      :settings="settings"
    />
    <Reports
      v-if="isReportModule || isONEProject"
      :settings="settings"
    />
  </div>
</template>

<script>
import SMTP from './component/SMTP';
import RPTrage from './component/RPTrage';
import Reports from './component/Reports';

export default {
  name: 'Email',
  components: { SMTP, RPTrage, Reports },
  props: {
    settings: {
      type: Object,
      default: () => {}
    },
    isRPTradeModule: {
      type: Boolean,
      default: false
    },
    isReportModule: {
      type: Boolean,
      default: false
    },
    isONEProject: {
      type: Boolean,
      default: false
    },
  },
  data: function() {
    return {};
  }
};
</script>
